import { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Dot, Bookmark, Play, Star, TriangleAlert, X } from 'lucide-react';
import Footer from "../../components/footer/footer";
import profil from '../assets/profil.jpg'
import { Helmet } from "react-helmet";



export default function Info() {
    const [OverviewSeeMore, setOverviewSeeMore] = useState(false);
    const [howsClicking, setHowsClicking] = useState();
    const [trailerseasons, setTrailerSeasons] = useState([]);
    const [urlMediaType] = useSearchParams()
    const media_type = urlMediaType.getAll('type')
    const [movie, setMovie] = useState({})
    const [cast, setCast] = useState([])
    const [videos, setVideos] = useState([])
    const [similar, setSimilar] = useState([])
    const [Genre, setGenre] = useState([])
    const [seasons, setSeasons] = useState([])
    const [selectSeason, setSelectSeason] = useState(localStorage.season && localStorage.season < movie?.seasons?.length ? Number(localStorage.season) : 1)
    const [selectEpisodes, setSelectEpisodes] = useState(localStorage.episode ? Number(localStorage.episode) : 1)
    const [fetchSeason, setFetchSeason] = useState([]);
    const [showStream, setShowStream] = useState(media_type == 'movie' ? true : false)
    const params = useParams();
    const navigate = useNavigate()
    const [displayModaltrailler, setdisplayModaltrailler] = useState(false)

    const useRunOnce = ({ fn, sessionKey }) => {
        const triggered = useRef(false);

        useEffect(() => {
            const hasBeenTriggered = sessionKey
                ? sessionStorage.getItem(sessionKey)
                : triggered.current;

            if (!hasBeenTriggered) {
                fn();
                triggered.current = true;

                if (sessionKey) {
                    sessionStorage.setItem(sessionKey, "true");
                }
            }
        }, [fn, sessionKey]);

        return null;
    };

    useRunOnce({
        fn: () => {
            window.scrollTo(0, 0)
        }
    });


    useEffect(() => {
        async function fetchdMoviedetails() {
            await fetch(`https://api.themoviedb.org/3/movie/${params.id}?api_key=091d4817f9045622142ffd67a08b2d15`)
                .then(response => response.json())
                .then(response => setMovie(response))
        }

        async function fetchdTvdetails() {
            await fetch(`https://api.themoviedb.org/3/tv/${params.id}?api_key=091d4817f9045622142ffd67a08b2d15`)
                .then(response => response.json())
                .then(response => setMovie(response));
        }

        async function fetchdTvdCast() {
            await fetch(`https://api.themoviedb.org/3/${media_type}/${params.id}/credits?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setCast(response.cast))
        }

        async function fetchdMovieCast() {


            await fetch(`https://api.themoviedb.org/3/${media_type}/${params.id}/credits?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setCast(response.cast))
        }

        async function fetchdMovieVideo() {
            await fetch(`https://api.themoviedb.org/3/movie/${params.id}/videos?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setVideos(response.results))
        }

        async function fetchdTvVideo() {
            await fetch(`https://api.themoviedb.org/3/tv/${params.id}/videos?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setVideos(response.results))
        }

        async function fetchSimilarMovies() {
            await fetch(`https://api.themoviedb.org/3/${media_type}/${params.id}/recommendations?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setSimilar(response.results))
        }

        async function fetchSimilarTvs() {
            await fetch(`https://api.themoviedb.org/3/${media_type}/${params.id}/recommendations?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setSimilar(response.results))
        }

        async function fetchGenreMovies() {
            await fetch(`https://api.themoviedb.org/3/genre/movie/list?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setGenre(response.genres))
        }

        async function fetchGenreTvs() {
            await fetch(`https://api.themoviedb.org/3/genre/tv/list?api_key=091d4817f9045622142ffd67a08b2d15&language=en-US`)
                .then(response => response.json())
                .then(response => setGenre(response.genres))
        }
        media_type == 'movie' ? fetchdMoviedetails() : fetchdTvdetails()
        media_type == 'movie' ? fetchdMovieCast() : fetchdTvdCast()
        media_type == 'movie' ? fetchdMovieVideo() : fetchdTvVideo()
        media_type == 'movie' ? fetchSimilarMovies() : fetchSimilarTvs()
        media_type == 'movie' ? fetchGenreMovies() : fetchGenreTvs()

        setSelectEpisodes(localStorage.episode ? Number(localStorage.episode) : 1)

    }, [params.id])

    useEffect(() => {
        async function fetchTvSeasonsdetails() {
            await fetch(`https://api.themoviedb.org/3/tv/${params.id}/season/${selectSeason}?api_key=091d4817f9045622142ffd67a08b2d15`)
                .then(response => response.json())
                .then(response => setFetchSeason(response))
        }

        async function fetchTvSeasonsTrailllers() {
            await fetch(`https://api.themoviedb.org/3/tv/${params.id}/season/${selectSeason}/videos?api_key=091d4817f9045622142ffd67a08b2d15`)
                .then(response => response.json())
                .then(response => setTrailerSeasons(response.results))
        }

        media_type == 'movie' ? console.log('') : fetchTvSeasonsdetails()
        media_type == 'movie' ? console.log('') : fetchTvSeasonsTrailllers()

    }, [selectSeason, params.id])

    function handleSelectSeasons(e) {
        setFetchSeason([])
        setSelectSeason(e.target.value)
    }
    const handlechangeDisplayTrailer = () => {
        setdisplayModaltrailler(!displayModaltrailler)
    }

    const year = String(movie.release_date).slice(0, 4)
    const yearTv = String(movie.first_air_date).slice(0, 4)
    let Trailer;
    videos?.map(v => v.type === "Trailer" ? Trailer = v : '');

    let SeasonsTrailer;
    trailerseasons?.map(v => v.type === 'Trailer' ? SeasonsTrailer = v : '');


    useEffect(() => {
        setSeasons(movie.seasons)
    }, [movie])


    localStorage.episode = selectEpisodes
    localStorage.season = selectSeason

    const genres_list = []
    movie?.genres?.map(v =>
        genres_list.push(v.name)
    )

    const g = genres_list.join(',')

    return (
        <div className="text-white flex flex-col">

            {/* backdrop image at the top */}
            <div className="relative ">
                <div className="absolute h-full w-full bg-gradient-to-t z-30 from-[#000000]  to-100% to-transparent">
                </div>
                <img src={movie.backdrop_path ? `https://image.tmdb.org/t/p/original/${movie.backdrop_path}` : '/backdropNotFound.jpg'} alt={`${movie.title}`} className="t9iil w-full" />

                <div className="absolute  bottom-0 md:bottom-32 px-4 lg:px-10 z-50 flex items-end gap-3 " >
                    <div className="">
                        <img src={movie.poster_path ? `https://image.tmdb.org/t/p/w500/${movie.poster_path}` : '/posternotFound.jpg'} alt="" className={`rounded-xl shadow-lg w-40 sm:w-52 shadow-[#7300FF60] t9iil`} />
                    </div>
                    <div className="mb-2">
                        <p>{media_type == 'movie' ? year === 'unde' ? '' : year : yearTv === 'unde' ? '' : yearTv}</p>
                        <h1 className="text-2xl lg:text-5xl font-semibold mb-0 md:mb-3">{media_type == 'movie' ? movie.title : movie.name}</h1>
                        <Helmet>
                            <title>{media_type == 'movie' ? `${movie?.title}` : `${movie?.name} `} | HF Universe</title>
                            <meta name="description" content={`Stream ${media_type == 'movie' ? movie?.title : movie.name} and thousands of movies and TV shows online. High-quality streaming with no interruptions. Watch now on YourSite.`} />
                            <meta name="keywords" content={`stream movies, watch TV shows, online streaming, HD movies, ${media_type == 'movie' ? movie.title : movie.name} , free streaming`} />
                            <meta name="robots" content="index, follow" />
                            <link rel="canonical" href={`https://hf-universe.vercel.app/${params.id}?type=${media_type}`} />


                            <script type="application/ld+json">
                                {
                                    media_type == 'movie' ? JSON.stringify({
                                        "@context": "https://schema.org",
                                        "@type": "Movie",
                                        "name": movie.title,
                                        "datePublished": movie.release_date,
                                        "image": ` ${`https://image.tmdb.org/t/p/w500/${movie.poster_path} `}`,
                                        "genre": g,
                                        "duration": `PT${movie.runtime}M`,
                                        "description": movie.overview,
                                        "aggregateRating": {
                                            "@type": "AggregateRating",
                                            "ratingValue": movie.vote_average,
                                            "reviewCount": movie.vote_count
                                        },
                                    })
                                        :
                                        JSON.stringify({
                                            "@context": "https://schema.org",
                                            "@type": "TVSeries",
                                            "name": movie.name,
                                            "genre": g,
                                            "datePublished": movie.first_air_date,
                                            "numberOfSeasons": movie.number_of_seasons,
                                            "numberOfEpisodes": movie.number_of_episodes,
                                            "image": `${`https://image.tmdb.org/t/p/w500/${movie.poster_path} `}`
                                        })
                                }

                            </script>
                        </Helmet>
                        <div className="flex items-center gap-2 font-semibold text-lg mb-1 md:mb-2">
                            {
                                media_type == 'tv' ? <p className="text-sm md:text-lg text-nowrap  bg-[#7300FF50]  rounded-lg px-1">{movie.number_of_seasons}<span className="opacity-0">.</span>Seasons</p> : ''
                            }
                            <div className=" h-6 overflow-hidden">
                                {
                                    movie.genres ?
                                        movie.genres.map((v, i) =>
                                            <span key={i} className="text-sm md:text-lg ">
                                                <span className="text-nowrap">{v.name} </span>
                                                {movie?.genres?.length - 1 !== i ? <span><Dot className="inline-block -mx-1" /></span> : ''}
                                            </span>
                                        )
                                        : ''
                                }
                            </div>
                        </div>
                        <div className="flex gap-2 ">
                            <a href='#episodes' className='flex rounded-tr-xl backdrop-blur-lg  bg-[#7300FF] rounded-bl-xl py-1 px-2 md:px-4 md:py-2 gap-1'>
                                <Play strokeWidth={3} /><span className='text-nowrap'>Watch<span className="opacity-0">.</span>Now</span>
                            </a>
                            <button className='flex rounded-tr-xl backdrop-blur-lg  bg-[#ffffff10] rounded-bl-xl py-1 px-2 md:px-4 md:py-2 gap-1' onClick={() => { handlechangeDisplayTrailer(); setHowsClicking(1) }}>
                                <Play strokeWidth={3} /><span className='text-nowrap'>Watch<span className="opacity-0">.</span>Trailer</span>
                            </button>
                            <button className=' rounded-tr-xl bg-[#7300FF20] border border-white  rounded-bl-xl py-1 px-2 md:px-4 md:py-2 gap-1 hidden sm:flex'>
                                <Bookmark strokeWidth={3} /><span className='text-nowrap'>Add<span className="opacity-0">.</span>to<span className="opacity-0">.</span>Wishlist</span>
                            </button>

                        </div>
                    </div>

                </div>
            </div>

            {/* trailer modal  */}
            <div onClick={() => setdisplayModaltrailler(false)} className={`w-[100vw] -mt-20 lg:mt-0 h-svh   md:h-[100vh] fixed bg-[#000000a4] z-[1000] justify-center items-center flex ${displayModaltrailler ? 'block' : 'hidden'} t9iil`}>
                <div className='bg-[#7300FF40] backdrop-blur-lg border-[1px]  border-[#7300FF80] shadow-2xl  w-[90%]  lg:w-[60%]  rounded-2xl  ml-auto mr-auto t9iil px-3  py-3'>
                    <div className='flex justify-between items-center  rounded-tr-2xl rounded-tl-2xl px-2'>
                        <h1 className=" md:text-4xl font-bold my-3  text-nowrap">{howsClicking === 1 ? Trailer?.name : SeasonsTrailer?.name}</h1>
                        <button className='rounded-full p-2 bg-[#00000051] border-[#7300FF40] border-[1px] hover:bg-[#39393951]' onClick={handlechangeDisplayTrailer}>
                            <X color='white' size={20} /></button>
                    </div>
                    <hr />

                    {/* watch Triller */}
                    <div className="relative overflow-hidden w-[100%] h-[100%]  pt-[56.25%] mt-2">
                        {
                            videos[0] && displayModaltrailler ? <iframe className="absolute top-0 bottom-0 right-0 left-0 w-[100%] h-[100%] rounded-2xl " src={`https://www.youtube.com/embed/${howsClicking === 1 ? Trailer?.key : SeasonsTrailer?.key}`}></iframe> : ''
                        }
                    </div>
                </div>
            </div>

            {/* overview of the show */}
            <div className="6 w-full bg-black z-50 mt-5 md:mt-0 px-4 lg:px-10">
                <h1 className="text-white text-4xl font-semibold my-3">Synopsis</h1>
                <p className="ztext-xl">{movie.overview}</p>
            </div>

            {/* cast */}
            <div className="px-4 lg:px-10 my-24 z-50">
                {/* cast display */}
                <h1 className="text-4xl font-bold my-3">Cast</h1>
                <div className="flex gap-10 scroll overflow-auto py-4
                    [&::-webkit-scrollbar]:h-1
                    [&::-webkit-scrollbar-track]:rounded-full
                    [&::-webkit-scrollbar-track]:bg-gray-100
                    [&::-webkit-scrollbar-thumb]:rounded-full 
                    [&::-webkit-scrollbar-thumb]:bg-gray-300
                    dark:[&::-webkit-scrollbar-track]:bg-[#7300FF10]
                    dark:[&::-webkit-scrollbar-thumb]:bg-[#7300FF]">
                    {
                        cast && cast.length > 0 ? cast.map((c, i) =>
                            <div key={i} className="flex items-center justify-center gap-2" >
                                <div className="rounded-full overflow-hidden bg-red-200 w-20 h-20">
                                    <img src={c.profile_path ? `https://image.tmdb.org/t/p/w300/${c.profile_path}` : profil} alt="" className={` bottom-3 relative ${c.profile_path ? 'w-20 lg:w-[113px]' : 'top-[0.1px]  '}`} />
                                </div>
                                <div>
                                    <h1 className="text-nowrap text-lg md:text-2xl text-semibold">{String(c.name).split(' ').map(v => <><span className="text-white">{v}</span><span className="opacity-0">.</span></>)}</h1>
                                    <span className="text-nowrap text-sm text-[#7300ffe0] ">{String(c.character).split(' ').map(v => <><span className="text-[#7300FF]">{v}</span><span className="opacity-0">.</span></>)}</span>
                                </div>
                            </div>)
                            : <div className="text-center w-full flex justify-center gap-3 text-[#7300FF] ">
                                <TriangleAlert size={40} />
                                <h1 className="text-4xl font-semibold  text-white">No Cast found</h1>
                            </div>
                    }
                </div>
            </div>



            {/* streming shows */}
            <div className="px-4 lg:px-10 mb-3">
                <h1 className="text-3xl font-bold ">{media_type == 'tv' ? '' : "Streaming Movie"}</h1>
                <div className="flex justify-between items-center mb-6">
                    <div>
                        {media_type == 'tv' ?
                            seasons?.map((v, i) =>
                                selectSeason == (v.season_number == 0 ? i + 1 : i) && v.season_number != 0 ?
                                    <span className="text-2xl md:text-3xl font-bold   " key={i}>Episodes 1-{v.episode_count} </span>
                                    : <div></div>)
                            : ''
                        }
                    </div>

                    <div className=" ">
                        {
                            media_type == 'tv' ?
                                <select value={selectSeason} name="" id="" className="text-white border-white border-[1px] font-bold bg-[#7300ff31] px-4 py-2 outline-none rounded-tr-lg rounded-bl-lg" onChange={handleSelectSeasons}>
                                    <option value="1" className="text-black font-bold">Season</option>
                                    {
                                        Array.from(Array(movie.number_of_seasons), (v, i) => <option key={i} value={i + 1} className="text-black font-bold">{i + 1}</option>)
                                    }
                                </select>
                                : ''
                        }
                    </div>

                </div>

                {/* episodes details*/}
                <div className="flex justify-center">
                    <div className="flex flex-wrap justify-center gap-3" id="episodes">
                        {
                            fetchSeason?.episodes?.map((v, i) =>
                                v.still_path ?
                                    <a href="#videoplay" onClick={() => { setSelectEpisodes(v.episode_number); setShowStream(true) }} className={`relative cursor-pointer flex-shrink-0 w-fit h-fit rounded-xl overflow-hidden group  ${v.episode_number === selectEpisodes ? ' shadow-sm shadow-white' : ''} `} >
                                        <div className={`w-96 h-[213px] md:w-72 md:h-[162px]  bg-gradient-to-t from-black to-transparent absolute flex flex-col justify-between group-hover:bg-[#7300ff3a] duration-300 ${v.episode_number === selectEpisodes ? 'bg-[#7300ff66] ' : ''}`}>
                                            <div className="h-full w-full flex justify-center items-center">
                                                <div className="bg-[#7300FF] flex justify-center items-center rounded-full w-10 h-10 group-hover:scale-125 duration-300" >
                                                    <Play strokeWidth={3} fill="white" className="relative left-[2px]" size={25} />
                                                </div>
                                            </div>
                                            <div>

                                            </div>
                                            <h1 className="flex justify-between items-end px-2">
                                                <span>
                                                    <span className="text-[#7300ff]">EP:{v.episode_number}</span> {v.name}
                                                </span>
                                                <span>{v.runtime}<span className="text-[#7300ff]"><span className="opacity-0">.</span>min</span></span>

                                            </h1>

                                        </div>
                                        <img src={v?.still_path ? `https://image.tmdb.org/t/p/w500/${v.still_path}` : '/backdropNotFound.jpg'} alt="" className="w-96 h-[213px] md:w-72 md:h-[162px]  rounded-xl " />
                                    </a>
                                    : <a href="#videoplay" onClick={() => { setSelectEpisodes(v.episode_number); setShowStream(true) }} className={`bg-[#7300ff6f] px-4 py-2 flex items-center gap-2 rounded-lg cursor-pointer hover:border-[1px] ${v.episode_number === selectEpisodes ? 'border-[1px] ' : ''} `}>
                                        <div className="bg-[#7300FF] flex justify-center items-center rounded-full p-1">
                                            <Play strokeWidth={3} fill="white" className="relative left-[2px]" size={20} />
                                        </div>
                                        <h1 className="text-center ">
                                            {v.name}
                                        </h1>
                                    </a>
                            )
                        }
                    </div>
                </div>

                {/* streaming  */}
                <div id="videoplay" className={`${showStream ? 'block' : 'hidden'}`}>
                    <div class="mt-2 bg-gray-500 text-sm text-white rounded-lg p-4" >
                        if you have any error while streaming, please reload the page or choose another server below .
                    </div>
                    <div className="relative overflow-hidden w-[100%] pt-[56.25%] mt-3">
                        <iframe id="iframe" className="absolute top-0 bottom-0 right-0 left-0 w-[100%] h-[100%] border-[#7300FF] border-2 rounded-3xl py-4 "
                            src={media_type == 'movie' ? `https://vidsrc.xyz/embed/movie/${params.id}` : `https://vidsrc.xyz/embed/tv/${params.id}/${selectSeason}-${selectEpisodes}`}
                            // src={media_type == 'movie' ? `` : `https://moviesapi.club/tv/${params.id}-${selectSeason}-${selectEpisodes}`}
                            scrolling="no" frameBorder="0" allowFullScreen ></iframe>
                    </div>

                    {/* servers  */}
                    <div className="text-white  mt-6">
                        <h1 className="text-4xl font-bold">Servers</h1>
                        <div className="flex justify-center gap-3 py-1 rounded-xl">
                            <button className="bg-[#ffffff10] px-6 py-3 rounded-lg border-[1px] hover:bg-[#7300FF60] duration-300 " onClick={() => document.getElementById('iframe').src = media_type == 'movie' ? `https://vidsrc.xyz/embed/movie/${params.id}` : `https://vidsrc.xyz/embed/tv/${params.id}/${selectSeason}-${selectEpisodes}`}>Server 1</button>
                            <button className=" bg-[#ffffff10] px-6 py-3 rounded-lg border-[1px] hover:bg-[#7300FF60] duration-300 " onClick={() => document.getElementById('iframe').src = media_type == 'movie' ? `https://moviesapi.club/movie/${params.id}` : `https://moviesapi.club/tv/${params.id}-${selectSeason}-${selectEpisodes}`}>Server 2 (less ads)</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* season details*/}
            {media_type == 'tv' ? <div id='movie_detail' className="px-4 lg:px-10 mt-20">
                <div className="rounded-xl border-[1px border-[#7300FF px-4 py-4 flex flex-col md:flex-row items-center  gap-6">
                    <div>
                        <img src={`https://image.tmdb.org/t/p/w500/${fetchSeason.poster_path}`} alt="" className="w-72 md:w-60 rounded-xl" />
                    </div>

                    <div className="space-y-3  ">
                        <h2 className="text-2xl md:text-3xl">{movie.name} - {fetchSeason.name}</h2>
                        <div className="flex gap-3 items-center">
                            {
                                SeasonsTrailer &&
                                <button className='flex rounded-tr-xl backdrop-blur-lg  bg-[#ffffff10] rounded-bl-xl  px-4 py-2 gap-1' onClick={() => { handlechangeDisplayTrailer(); setHowsClicking(2) }}>
                                    <Play strokeWidth={3} /><span className='text-nowrap'>Watch<span className="opacity-0">.</span>Trailer</span>
                                </button>
                            }

                            <span className="flex gap-1 items-center"> {SeasonsTrailer ? '' : <span>Vote :</span>} <Star size={20} color="yellow" fill="yellow" /> <span>{fetchSeason.vote_average}</span> </span>
                        </div>
                        <div className="flex flex-col md:flex-row gap-10">
                            {
                                fetchSeason?.overview &&
                                <div className="max-w-96 ">
                                    <h1>Overview :</h1>
                                    <p> {
                                        OverviewSeeMore ?
                                            <span>{fetchSeason?.overview} <span className="text-[#7300ff] cursor-pointer" onClick={() => setOverviewSeeMore(false)}> See less</span> </span>
                                            :
                                            <span>
                                                {String(fetchSeason?.overview)?.split(' ').slice(0, 50).join(' ')}

                                                {String(fetchSeason?.overview)?.split(' ').length < 50 ? '' :
                                                    <span className="text-[#7300ff] cursor-pointer" onClick={() => setOverviewSeeMore(true)}> See More</span>}
                                            </span>
                                    }
                                    </p>
                                </div>
                            }

                            <div className="max-w-96">
                                {
                                    fetchSeason.air_date &&
                                    <h1>Released : <span className="text-[#b9b9b9]">{fetchSeason.air_date}</span> </h1>
                                }
                                {
                                    movie.genres &&
                                    <h1>Genre : <span className="text-[#b9b9b9]">{movie.genres?.map((v, i, arr) => <span> {v.name} {arr.length > i + 1 ? ',' : ''}</span>)}</span> </h1>
                                }
                                {
                                    movie?.production_companies ?
                                        <h2> Country : <span className="text-[#b9b9b9]">{movie?.production_countries?.map(v => <span>{v.name}</span>)}</span> </h2> : ''
                                }
                                {
                                    movie?.production_companies &&
                                    <h2> Production : <span className="text-[#b9b9b9]">{movie?.production_companies?.map(v => <span>{v.name}</span>)}</span> </h2>
                                }
                            </div>
                            <div className="flex flex-col gap-2">
                                <span>Network{movie?.networks?.length > 1 ? 's' : ''} :</span>
                                <div className="flex flex-wrap gap-2 items-center">
                                    {
                                        movie?.networks?.slice(0, 3).map(v =>
                                            <div className="flex flex-col items-center">
                                                <span className="bg-white p-3 rounded-lg flex flex-col gap-1">
                                                    <img src={`https://image.tmdb.org/t/p/w500/${v.logo_path}`} className="w-24 aspect-[3] object-contain" />
                                                </span>
                                                <span className="text-center">{v.name}</span>
                                            </div>)
                                    }
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div> :
                <div id='season_detail' className="px-4 lg:px-10 mt-20">
                    <div className="rounded-xl border-[1px border-[#7300FF px-4 py-4 flex flex-col md:flex-row items-center  gap-6">
                        <div>
                            <img src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt="" className="w-72 md:w-60 rounded-xl" />
                        </div>

                        <div className="space-y-3  ">
                            <h2 className="text-2xl md:text-3xl">{movie.title}</h2>
                            <div className="flex gap-3 items-center">
                                <span className="flex gap-1 items-center"> {SeasonsTrailer ? '' : <span>Vote :</span>} <Star size={20} color="yellow" fill="yellow" /> <span>{movie.vote_average}</span> </span>
                            </div>
                            <div className="flex flex-col md:flex-row gap-10">
                                <div className="max-w-96">
                                    {
                                        fetchSeason.air_date &&
                                        <h1>Released : <span className="text-[#b9b9b9]">{movie.release_date}</span> </h1>
                                    }
                                    {
                                        movie.genres &&
                                        <h1>Genre : <span className="text-[#b9b9b9]">{movie.genres?.map((v, i, arr) => <span> {v.name} {arr.length > i + 1 ? ',' : ''}</span>)}</span> </h1>
                                    }
                                    {
                                        movie?.production_companies ?
                                            <h2> Country : <span className="text-[#b9b9b9]">{movie?.production_countries?.map(v => <span>{v.name}</span>)}</span> </h2> : ''
                                    }
                                    {
                                        movie?.production_companies &&
                                        <h2> Production : <span className="text-[#b9b9b9]">{movie?.production_companies?.map(v => <span>{v.name}</span>)}</span> </h2>
                                    }
                                </div>
                                <div className="flex flex-col gap-2">
                                    <span>Network{movie?.production_companies?.length > 1 ? 's' : ''} :</span>
                                    <div className="flex flex-wrap gap-2 items-center">
                                        {
                                            movie?.production_companies?.slice(0, 3)?.map(v => v.logo_path &&
                                                <div className="flex flex-col items-center">
                                                    <span className="bg-white p-3 rounded-lg flex flex-col gap-1">
                                                        <img src={`https://image.tmdb.org/t/p/w500/${v.logo_path}`} className="w-24  aspect-[3] object-contain " />
                                                    </span>
                                                    <span className="text-center text-sm">{v.name}</span>
                                                </div>)
                                        }
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            }



            {/* similar movies or tv shows */}
            <div className="mt-20 px-4 lg:px-10">
                <h1 className="text-4xl font-semibold py-6">Similar {media_type == 'movie' ? 'Movies' : 'Shows'} for you</h1>

                <div className="flex gap-6 overflow-auto [&::-webkit-scrollbar]:h-1
                    [&::-webkit-scrollbar-track]:rounded-full
                    [&::-webkit-scrollbar-track]:bg-gray-100
                    [&::-webkit-scrollbar-thumb]:rounded-full 
                    [&::-webkit-scrollbar-thumb]:bg-gray-300
                    dark:[&::-webkit-scrollbar-track]:bg-[#7300FF10]
                    dark:[&::-webkit-scrollbar-thumb]:bg-[#7300FF] py-6">
                    {
                        similar && similar.length > 0 ? similar.map((v, i) =>
                            <a href="" key={i} className="flex-shrink-0 w-72 md:w-96 " onClick={() => {
                                navigate(`/${v?.id}?type=${v?.media_type}`)
                            }}>
                                <img src={v.backdrop_path ? `https://image.tmdb.org/t/p/w500/${v.backdrop_path}` : '/backdropNotFound.jpg'} alt="" className=" w-72 md:w-96 rounded-xl" />
                                <div>
                                    <h1 className="text-xl font-semibold">{media_type == 'movie' ? v.title : v.name}</h1>
                                    <div className="flex items-center gap-2">
                                        <Star color="yellow" fill="yellow" />
                                        <span className="text-[#c0a6ff] font-bold">{String(v.vote_average).slice(0, 4)}</span>
                                        <hr className="w-3 border-[#a473ff] rotate-90" />

                                        <div className=" flex text-[#a473ff]">
                                            {
                                                Genre.map((g, i) =>
                                                    v.genre_ids[0] === g.id ? <span key={i}>{g.name}</span> : ''
                                                )
                                            }
                                            {v.genre_ids[1] ? <Dot /> : ''}
                                            {
                                                Genre.map(g =>
                                                    v.genre_ids[1] === g.id ? <span key={i}>{g.name}</span> : ''
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            </a>
                        )
                            : <div className="text-center w-full flex justify-center gap-3 text-[#7300FF] ">
                                <TriangleAlert size={40} />
                                <h1 className="text-4xl font-semibold  text-white">No Similar {media_type == 'movie' ? 'Movies' : "Tv Shows"} found</h1>
                            </div>
                    }
                </div>
            </div>
            <Footer />

        </div >
    )
}

